"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsSuggestGroupsDrawer = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var formatConfidence = function (confidence) { return Math.round(confidence * 100) + "%"; };
/**
 * Right-hand drawer that lists AI-proposed element groups for the
 * current element type. Each row shows the proposed name, rationale,
 * confidence, alternative names (admin can swap), and the cluster
 * members. The admin can deselect members before applying — only
 * checked elements get linked, the rest stay ungrouped for the next
 * suggest pass.
 */
exports.MetricsSuggestGroupsDrawer = function (_a) {
    var isOpen = _a.isOpen, onDismiss = _a.onDismiss, elementType = _a.elementType, suggestions = _a.suggestions, isLoading = _a.isLoading, error = _a.error, onApply = _a.onApply;
    var safeSuggestions = Array.isArray(suggestions) ? suggestions : [];
    var _b = react_1.useState(null), busyIndex = _b[0], setBusyIndex = _b[1];
    var _c = react_1.useState(null), editState = _c[0], setEditState = _c[1];
    var _d = react_1.useState(new Set()), appliedIndexes = _d[0], setAppliedIndexes = _d[1];
    var beginEdit = function (index, suggestion) {
        setEditState({
            index: index,
            groupName: suggestion.groupName,
            description: suggestion.rationale,
            memberElementIds: suggestion.members.map(function (m) { return m.elementId; }),
        });
    };
    var toggleMember = function (elementId) {
        setEditState(function (current) {
            if (!current)
                return current;
            var has = current.memberElementIds.indexOf(elementId) >= 0;
            return __assign(__assign({}, current), { memberElementIds: has
                    ? current.memberElementIds.filter(function (id) { return id !== elementId; })
                    : current.memberElementIds.concat(elementId) });
        });
    };
    var apply = function (index, suggestion) { return __awaiter(void 0, void 0, void 0, function () {
        var draft, groupName, memberElementIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    draft = editState && editState.index === index ? editState : null;
                    groupName = (draft ? draft.groupName : suggestion.groupName).trim();
                    memberElementIds = draft
                        ? draft.memberElementIds
                        : suggestion.members.map(function (m) { return m.elementId; });
                    if (!groupName || memberElementIds.length === 0) {
                        return [2 /*return*/];
                    }
                    setBusyIndex(index);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, onApply({
                            groupName: groupName,
                            description: draft ? draft.description : suggestion.rationale,
                            memberElementIds: memberElementIds,
                        })];
                case 2:
                    _a.sent();
                    setAppliedIndexes(function (current) {
                        var next = new Set(current);
                        next.add(index);
                        return next;
                    });
                    setEditState(null);
                    return [3 /*break*/, 4];
                case 3:
                    setBusyIndex(null);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(office_ui_fabric_react_1.Panel, { isOpen: isOpen, onDismiss: onDismiss, type: office_ui_fabric_react_1.PanelType.medium, headerText: "Suggested groups (" + safeSuggestions.length + ")", isLightDismiss: true, closeButtonAriaLabel: "Close suggestions panel" },
        isLoading && (react_1.default.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.medium, label: "Clustering ungrouped elements and asking the agent for names\u2026" })),
        error && (react_1.default.createElement("div", { style: { color: '#a4262c', marginBottom: 12 } },
            "Failed to suggest groups: ",
            error)),
        !isLoading && !error && safeSuggestions.length === 0 && (react_1.default.createElement("div", { style: { marginTop: 24, color: '#605e5c' } },
            "No suggestions for ",
            react_1.default.createElement("strong", null, elementType),
            " right now. Either every embedded element is already grouped, or there aren\u2019t enough similar ones yet (need at least three).")),
        safeSuggestions.map(function (suggestion, index) {
            var isBusy = busyIndex === index;
            var isApplied = appliedIndexes.has(index);
            var isEditing = editState !== null && editState.index === index;
            var draft = isEditing ? editState : null;
            return (react_1.default.createElement("div", { key: suggestion.groupName + "-" + index, style: {
                    border: '1px solid #edebe9',
                    borderRadius: 4,
                    padding: 12,
                    marginBottom: 12,
                    background: isApplied ? '#f3f9f1' : '#fff',
                    opacity: isApplied ? 0.7 : 1,
                } },
                react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'baseline', gap: 8 } },
                    isEditing ? (react_1.default.createElement(office_ui_fabric_react_1.TextField, { value: draft.groupName, onChange: function (_, nextValue) {
                            return setEditState(function (c) { return (c ? __assign(__assign({}, c), { groupName: nextValue || '' }) : c); });
                        }, styles: { root: { flex: 1, minWidth: 220 } }, ariaLabel: "Group name" })) : (react_1.default.createElement("h3", { style: { margin: 0, flex: 1 } }, suggestion.groupName)),
                    react_1.default.createElement("span", { style: {
                            fontSize: 12,
                            color: suggestion.confidence >= 0.7
                                ? '#107c10'
                                : suggestion.confidence >= 0.5
                                    ? '#605e5c'
                                    : '#a4262c',
                        } },
                        "confidence\u00A0",
                        formatConfidence(suggestion.confidence))),
                isEditing ? (react_1.default.createElement(office_ui_fabric_react_1.TextField, { multiline: true, autoAdjustHeight: true, value: draft.description, onChange: function (_, nextValue) {
                        return setEditState(function (c) { return (c ? __assign(__assign({}, c), { description: nextValue || '' }) : c); });
                    }, styles: { root: { marginTop: 8 } }, ariaLabel: "Group description" })) : (react_1.default.createElement("p", { style: { marginTop: 6, color: '#605e5c' } }, suggestion.rationale)),
                suggestion.alternatives.length > 0 && !isEditing && (react_1.default.createElement("div", { style: { marginTop: 4, fontSize: 12, color: '#605e5c' } },
                    "Alternatives:",
                    ' ',
                    suggestion.alternatives.map(function (alt, altIndex) { return (react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { key: alt, text: alt, onClick: function () {
                            return setEditState({
                                index: index,
                                groupName: alt,
                                description: suggestion.rationale,
                                memberElementIds: suggestion.members.map(function (m) { return m.elementId; }),
                            });
                        }, styles: {
                            root: {
                                height: 22,
                                minWidth: 0,
                                padding: '0 8px',
                                marginRight: 4,
                                marginLeft: altIndex === 0 ? 4 : 0,
                            },
                            label: { fontSize: 11 },
                        } })); }))),
                react_1.default.createElement("details", { style: { marginTop: 8 } },
                    react_1.default.createElement("summary", { style: { cursor: 'pointer', fontSize: 13 } },
                        "Members (",
                        suggestion.members.length,
                        ")"),
                    react_1.default.createElement("ul", { style: { margin: '6px 0 0 0', paddingLeft: 18 } }, suggestion.members.map(function (member) {
                        var checked = isEditing
                            ? draft.memberElementIds.indexOf(member.elementId) >= 0
                            : true;
                        return (react_1.default.createElement("li", { key: member.elementId, style: { fontSize: 12, padding: '2px 0' } }, isEditing ? (react_1.default.createElement("label", { style: { display: 'flex', alignItems: 'center', gap: 6 } },
                            react_1.default.createElement("input", { type: "checkbox", checked: checked, onChange: function () { return toggleMember(member.elementId); } }),
                            react_1.default.createElement("strong", null, member.canonicalName),
                            member.description ? (react_1.default.createElement("span", { style: { color: '#605e5c' } },
                                " \u2014 ",
                                member.description)) : null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("strong", null, member.canonicalName),
                            member.description ? (react_1.default.createElement("span", { style: { color: '#605e5c' } },
                                " \u2014 ",
                                member.description)) : null))));
                    }))),
                react_1.default.createElement("div", { style: { display: 'flex', gap: 8, marginTop: 12 } }, isApplied ? (react_1.default.createElement("span", { style: { color: '#107c10', fontSize: 12 } }, "Applied \u2014 group created and members linked.")) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { text: isEditing ? 'Apply edited' : 'Apply', iconProps: { iconName: 'CheckMark' }, onClick: function () { return apply(index, suggestion); }, disabled: isBusy ||
                            (isEditing
                                ? !draft.groupName.trim() || draft.memberElementIds.length === 0
                                : false) }),
                    isEditing ? (react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Cancel edit", iconProps: { iconName: 'Undo' }, onClick: function () { return setEditState(null); }, disabled: isBusy })) : (react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Edit", iconProps: { iconName: 'Edit' }, onClick: function () { return beginEdit(index, suggestion); }, disabled: isBusy })),
                    isBusy && react_1.default.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.small }))))));
        }),
        react_1.default.createElement("div", { style: { marginTop: 16, display: 'flex', justifyContent: 'flex-end' } },
            react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Close", iconProps: { iconName: 'Cancel' }, onClick: onDismiss }))));
};
